export default __webpack_public_path__ + "static/media/2.e63987e8.png";